// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import RegisterForm from "../containers/RegisterForm";
import { useTranslation } from 'react-i18next';

export default function RegisterView() {
    const { t } = useTranslation();
  return (
      <PageContainer title={t("Register")} showShopToolbar={false}>
          <RegisterForm />
    </PageContainer>
  );
}
